import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=7a27caef&scoped=true&"
import script from "./Read.vue?vue&type=script&lang=js&"
export * from "./Read.vue?vue&type=script&lang=js&"
import style0 from "./Read.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Read.vue?vue&type=style&index=1&id=7a27caef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27caef",
  null
  
)

export default component.exports